import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.css'],
})
export class QuestionnaireComponent implements OnInit, OnChanges {
  @Input() questions: any[] = [];
  @Input() isSubmit: boolean = false;
  @Input() parentForm!: FormGroup;
  @Input() genInfo: any; // Input for general information
  @Input() financeInfo: any; // Input for financial information
  @Output() valueChange = new EventEmitter<any>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.initializeForm();
    this.addGeneralAndFinancialInfo(); // Add extra fields
    this.handleDependencies();
    this.parentForm.addControl('childForm', this.form);

    // Emit value changes
    this.form.valueChanges.subscribe(() => {
      this.valueChange.emit(this.form.value);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('isSubmit' in changes && !changes['isSubmit'].isFirstChange()) {
      this.isSubmit = changes['isSubmit'].currentValue;
    }
  }

  initializeForm() {
    this.form = this.fb.group({});
    this.questions.forEach((question) => {
      const control = this.createFormControl(question);
      this.form.addControl(question.questionId.toString(), control);
    });
  }

  addGeneralAndFinancialInfo() {
    if (this.genInfo) {
      Object.keys(this.genInfo).forEach((key) => {
        const control = this.fb.control(this.genInfo[key] || '', Validators.required);
        this.form.addControl(`genInfo.${key}`, control);
      });
    }

    if (this.financeInfo) {
      Object.keys(this.financeInfo).forEach((key) => {
        const control = this.fb.control(this.financeInfo[key] || '');
        this.form.addControl(`financeInfo.${key}`, control);
      });
    }
  }

  createFormControl(question: any): FormControl {
    const validators = this.getValidators(question);
    return this.fb.control('', validators);
  }

  getValidators(question: any) {
    const validators = [];
    if (question.mandatory) validators.push(Validators.required);
    if (question.validation?.pattern)
      validators.push(Validators.pattern(new RegExp(question.validation.pattern)));

    if (question.validation?.minLength)
      validators.push(Validators.minLength(question.validation.minLength));

    if (question.validation?.maxLength)
      validators.push(Validators.maxLength(question.validation.maxLength));

    if (question.validation?.min !== undefined)
      validators.push(Validators.min(question.validation.min));

    if (question.validation?.max !== undefined)
      validators.push(Validators.max(question.validation.max));

    if (question.validation?.customValidator)
      validators.push(question.validation.customValidator);
    return validators;
  }

  handleDependencies() {
    this.questions.forEach((question) => {
      if (question.dependency?.length) {
        question.dependency.forEach((dependency: any) => {
          const parentControl = this.form.get(dependency.questionId.toString());
          parentControl?.valueChanges.subscribe((value) => {
            const currentControl = this.form.get(question.questionId.toString());
            if (dependency.value.includes(value)) {
              currentControl?.enable();
            } else {
              currentControl?.disable();
              currentControl?.reset();
            }
          });
        });
      }
    });
  }

  getErrorMessage(controlName: string): string {
    const control = this.form.get(controlName);
    if (control?.hasError('required')) return 'This field is required.';
    if (control?.hasError('pattern')) return 'Invalid format.';
    return '';
  }
}
